const initCollectionDescription = () => {
  const descriptionEl = document.querySelector('[data-collection-description]');
  if (!descriptionEl) return;

  const toggleEl = document.querySelector('[data-collection-description-toggle]');
  if (!toggleEl || toggleEl.dataset.collectionDescriptionInit === 'true') return;

  const toggleShortTextEl = toggleEl.querySelector('[data-collection-description-toggle-short]');
  const toggleFullTextEl = toggleEl.querySelector('[data-collection-description-toggle-full]');
  const chevronEl = toggleEl.querySelector('[data-collection-description-chevron]');

  toggleEl.dataset.collectionDescriptionInit = 'true';

  toggleEl.addEventListener('click', () => {
    const isExpanded = toggleEl.getAttribute('aria-expanded') === 'true';
    descriptionEl.classList.toggle('line-clamp-3', isExpanded);
    toggleShortTextEl?.classList.toggle('hidden', !isExpanded);
    toggleFullTextEl?.classList.toggle('hidden', isExpanded);
    toggleEl.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    chevronEl?.classList.toggle('rotate-180', !isExpanded);
  });
};

export default initCollectionDescription;
